import AuraFXPage from "@/components/AuraFXPage";

const AuraGBPJPY = () => {
  return (
    <AuraFXPage
      instrument="GBPJPY"
      name="GBP/JPY"
      apiPath="/aura/gbpjpy"
    />
  );
};

export default AuraGBPJPY;
